// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './pc.vue'
import router from './router'
//import { max, sum } from '@/js/utils.js';

import axios from 'axios';
//axios
Vue.prototype.$axios = axios;

//global
import GLOBAL from '@/js/global.js';
Vue.prototype.$global = GLOBAL;

//login
import mslogin from '@/js/msLogin.js';
Vue.prototype.$mslogin = mslogin;
mslogin.defaults.loginUrl = GLOBAL.ajax_url_map.login;

// Toast
import Toast from '@/components/Toast';
Vue.prototype.$toast = Toast;

Vue.config.productionTip = false


// evt_rule_Modal
import Evt_rule_Modal from '@/components/EvtRule';
Vue.prototype.$evt_rule_modal = Evt_rule_Modal;

//clipboard
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;

// share_Modal
import Share_Modal from '@/components/Share';
Vue.prototype.$share_modal = Share_Modal;

// bind_Modal
import Bind_Modal from '@/components/AreaBind';
Vue.prototype.$bind_modal = Bind_Modal;

// check_Modal
import Check_Modal from '@/components/CheckModal';
Vue.prototype.$check_modal = Check_Modal;

// old_Modal
import Old_Modal from '@/components/OldModal';
Vue.prototype.$old_modal = Old_Modal;

// map_Modal
import Map_Modal from '@/components/MapModal';
Vue.prototype.$map_modal = Map_Modal;

// apply_Modal
import Apply_Modal from '@/components/ApplyModal';
Vue.prototype.$apply_modal = Apply_Modal;

// record_Modal
import Record_Modal from '@/components/RecordModal';
Vue.prototype.$record_modal = Record_Modal;

// friend_Modal
import Friend_Modal from '@/components/FriendModal';
Vue.prototype.$friend_modal = Friend_Modal;


//pin
import Pin from 'vue-pin'
// install
Vue.use(Pin)

// item_tips
import Item_Tips from '@/components/ItemTips';
Vue.prototype.$item_tips = Item_Tips;

//tips-pc
Vue.prototype.$tips_on = function(e,id){
    if(GLOBAL.deviceType != 'pc') return;
    mainApp.$refs.app.$refs.tips.visible = true;
    mainApp.$refs.app.$refs.tips.imgId = id;
    mainApp.$refs.app.$refs.tips.pos_data = {
        x : e.clientX,
        y : e.clientY,
    };
};

Vue.prototype.$tips_off = function(){
    mainApp.$refs.app.$refs.tips.visible = false;
};

Array.prototype.remove = function(val) {
  var index = this.indexOf(val);
  if (index > -1) {
  this.splice(index, 1);
  }
};

Vue.prototype.$update = function(){
  mainApp.update.call(mainApp);
};

Vue.prototype.$query_area = function(num){
    var area = '暂无大区信息';

    if (num == 1) {
        area = '火烧赤壁';
    } else if (num == 2) {
        area = '草船借箭';
    } else if (num == 6) {
        area = '荆州之战';
    } else if (num == 7) {
        area = '青梅煮酒';
    } else if (num == 8) {
        area = '官渡之战';
    } else if (num == 9) {
        area = '桃园结义';
    } else if (num == 11) {
        area = '九伐中原';
    } else if (num == 12) {
        area = '逐鹿中原';
    } else if (num == 13) {
        area = '三分天下';
    } else if (num == 16) {
        area = '怀旧服';
    }else if (num == 17) {
        area = '铜雀台';
    } else if (num == 18) {
        area = '凤仪亭';
    }else if (num == 19) {
        area = '火凤燎原';
    }else if (num == 20) {
        area = '卧龙出渊';
    }else if (num == 100) {
        area = '测试大区';
    }

    return area;
};

Vue.prototype.$score_update = function(num){
    mainApp.ua.score = num;
};

Vue.prototype.$get_invite_info = function(){
    mainApp.getInviteInfo.call(mainApp);
};

Vue.prototype.$bind = function(){
    mainApp.bind_area.call(mainApp);
};

Vue.prototype.$login_status = function(){
    return mainApp.login;
};

Vue.prototype.$bind_status = function(){
    return mainApp.ua.areaId;
};

//go /back
Vue.prototype.$go_back_page = function(){
    mainApp.$router.push('/back');
};

/* eslint-disable no-new */
const mainApp = new Vue({
  el: '#app_pc',
  router,
  components: { App },
  template: '<App :ready="ready" :ua="ua" :login="login" ref="app"/>',
  data (){
    return {
      ua : {},
      code : '',
      name : null,
      login : 0,//登陆
      aid : 0,//大区id
      account_type : 'pc',
      isLoading : false,
      ready : false,//通信阀门 
      account : 0,
      session : '',
      plat_auto_login : 0, 
      token : '',                  
    }
  },
  created () {
    var _v = this;

    let ajax_url_map = GLOBAL.ajax_url_map;

    let token = GLOBAL.getQueryVariable('authorization') || localStorage.getItem("token");
    _v.code = GLOBAL.getQueryVariable('code') || localStorage.getItem("_code");

    _v.token = token;

    if(document.location.href.indexOf('plat_auto_login')){
        _v.plat_auto_login = 1;
    }
    
    if(GLOBAL.getQueryVariable('account')){
        _v.account = GLOBAL.getQueryVariable('account');
    }

    if(GLOBAL.getQueryVariable('session')){
        _v.session = GLOBAL.getQueryVariable('session');
    }      
          

    var instance = axios.create();
    instance.defaults.timeout = 1000 * 20;
    axios.defaults.headers.post['Content-Type'] = 'application/json';

    /* 请求拦截 */
    this.$axios.interceptors.request.use(
        config => {

            if (_v.token != null) {
                config.headers["Authorization"] = _v.token;                  
            }

            config.headers["issn"] = GLOBAL.issn;
            
            return config;
        },
        err => Promise.reject(err)
    );

    //请求返回拦截
    this.$axios.interceptors.response.use((response) => {
        if (response.data.code === 402) {
            //其余错误状态处理
            if(!_v.code)_v.$bind();  
        }
        else if(response.data.code === 401) {
            //未登录
            
        }

        return response;

    }, function (error) {
        return Promise.reject(error);
    });

    if(_v.code){
        localStorage.setItem('_code', _v.code);           
    }

    if (token) {
        localStorage.setItem('token', token);
        if(GLOBAL.getQueryVariable('authorization')){
            // setTimeout(function () {
            //     window.location.href = GLOBAL.domain;
            // },100)
            window.history.pushState({}, 0, GLOBAL.domain);
        }
    }
    
    if(!_v.code)this.$router.push('/invite');
    this.update();
    if(_v.code){_v.getInviteInfo();}
  },
  methods : {
    update () {
      var _v = this;
      let ajax_url_map = GLOBAL.ajax_url_map;
      _v.isLoading = true;
      function getCustomerInfo(){
          return new Promise((resolve, reject) => {
              _v.$axios.get(ajax_url_map.logininfo, {
                  params: {
                      //r : +new Date()
                  }
              })
              .then(function (response) {
                  let _UA = response.data.data;
                  if (response.data.code === 0) {
                      _v.login = 1;
                      _v.name = _UA.uid;
                      _v.ua = _UA;
                      resolve();
                  }
                  else if (response.data.code === 2){
                      _v.login = 1;
                      _v.name = _UA.uid;
                      resolve();
                  }
                  else{
                      if(response.data.code == 9)_v.$toast(response.data.message);//活动结束
                      reject(response.data.message);
                  }
                  
                  if(_v.login)_v.account_type = response.data.data.fromType == 0 ? 'pc' : 'wg';                        
              })
              .catch(function (error) {
                  _v.$toast('请稍后再试');                 
                  console.log(error);
              });
          });
      }

      function normalLogin(){
          getCustomerInfo()
          .then(
              res => {
                  _v.$axios.post(_v.$global.ajax_url_map.userinfo)
                  .then(function(response){
                      _v.isLoading = false;
                      _v.ready = true; 
                      
                      var UA = response.data.data;
                      if(response.data.code == 0){
                          _v.ua = UA;
                          _v.aid = UA.areaId;
                          //TODO
                      }
                      else if(response.data.code == 2){
                          //if(!_v.code)return _v.$bind_modal();
                      }
                  })
                  .catch(function(error){
                      console.log(error);
                  });
              },
              rej => {
                  _v.isLoading = false;
                  _v.ready = true;                        
                  console.log(rej);
              }
          );
      }

      //梦平台
      if(_v.plat_auto_login && parseInt(_v.account) && _v.account != _v.ua.uid){
        _v.token = '';
          localStorage.clear();
          window.history.pushState({}, 0, GLOBAL.domain);

          _v.$axios.get(this.$global.ajax_url_map.mplat,{
              params : {
                  AccountId : _v.account,
                  SessionId : _v.session,
              }
          })
          .then(res => {
              if(res.data.code == 0){
                _v.token = res.data.data;
                normalLogin();
              }
              else{
                normalLogin();
              }
          },
          rej => {
              console.log(rej);
              normalLogin();
          })
      }
      else{
        normalLogin();
      }      

      //normalLogin();
      //this.get_task_list();            
    },
    getInviteInfo (){
        var _this = this;
        this.$axios.get(this.$global.ajax_url_map.invite_info,{
            params : {
                code : _this.code,
            }
        })
        .then(response => {
            if(response.data.code == 0){
                if(!response.data.data)return _this.$toast('请稍后再试');
                _this.$apply_modal({
                    code : _this.code,
                    playername : response.data.data,
                    login : _this.login,
                    aid : _this.aid,
                });
            }
            else{
                localStorage.setItem('_code', '');
                if(response.data.code != 404)return _this.$toast(response.data.message);
            }            
        });
    },
    bind_area (){
        this.$bind_modal({
            account_type : this.account_type,
        });
    },           
  },  
})



// WEBPACK FOOTER //
// ./src/view/pc/pc.js